import React from 'react';
import DistancePicker from '../shared/DistancePicker';
import OptionButton from '../shared/OptionButton';
import { getDistanceLimits } from '../onboardingQuestions';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const SKIP_TEXT = "I haven't run in the past 6 weeks";

const RecentRunHistoryStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  const limits = getDistanceLimits('recent_running_history', null);
  const isSkipped = answer === SKIP_TEXT;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 32, alignItems: 'center' }}>
      <DistancePicker
        value={answer && typeof answer === 'object' ? answer : null}
        onChange={onAnswer}
        minKm={limits.minKm}
        maxKm={limits.maxKm}
        minMiles={limits.minMiles}
        maxMiles={limits.maxMiles}
      />
      <OptionButton
        label={SKIP_TEXT}
        value={SKIP_TEXT}
        selected={isSkipped}
        onClick={onAnswer}
      />
    </div>
  );
};

export default RecentRunHistoryStep;
